<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <div>
        <b-form-group>
          <label>
            <b> {{ $t('chosen_table') }} </b>
          </label>
          <b-form-select v-model="table" :options="table_options" />
        </b-form-group>

        <unroll-element
          :title="$t('advanced_options_choice')"
          :available="true"
        >
          <b-form-group>
            <label>
              <b> {{ $t('result_filename') }} </b>
            </label>
            <b-form-input
              v-model="filename"
              :placeholder="$t('enter_filename')"
            />
          </b-form-group>
          <b-form-group>
            <label>
              <b> {{ $t('separator_choice') }} </b>
            </label>
            <b-form-select
              v-model="separator"
              :options="separatorchoiceoptions"
            />
          </b-form-group>

          <b-form-checkbox
            v-model="all_cols_chosen"
            :value="true"
            :unchecked-value="false"
            class="mb-4"
          >
            <b> {{ $t('choose_all_cols') }} </b>
          </b-form-checkbox>
          <columns-choice-options
            v-if="!all_cols_chosen"
            v-model="columns_wanted"
            :main_text="$t('wanted_columns')"
            :available_column_names="available_colnames"
          >
            <template #sub_component="props">
              <generic-column-name-edition
                v-bind="props"
                v-on="props.listeners"
              />
            </template>
          </columns-choice-options>
        </unroll-element>
      </div>

      <b-card :header="$t('download_file')">
        <b-row>
          <b-col offset="9">
            <b-button
              variant="outline-secondary"
              class="btn btn-block mt-3"
              :disabled="disabled_result"
              @click="download_result"
            >
              {{ $t('download_results') }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <b-card :header="$t('automatic_save')">
        <b-form-checkbox
          v-model="automatic_save"
          name="automatic_save"
          :value="true"
          :unchecked-value="false"
        >
          {{ $t('activate_automatic_save') }}
        </b-form-checkbox>
        <b-row>
          <b-col offset="1">
            <b-form-group :disabled="!automatic_save">
              <filepath-selector
                v-model="generic_resultpath"
                :is_open="false"
                placeholder="Chemin du fichier à sauvegarder"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col offset="1">
            <b-form-checkbox
              v-model="erase_resultfile_when_workflow_invalid"
              name="erase_resultfile_when_workflow_invalid"
              :value="true"
              :unchecked-value="false"
            >
              {{ $t('erase_resultfile_when_workflow_invalid') }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-card>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "result_filename": "Name given to the result file :",
    "enter_filename": "Enter the filename you want",
    "separator_choice": "Field separator",
    "choose_all_cols": "Choose all columns for output",
    "wanted_columns": "Wanted columns",
    "download_results": "Download result file",
    "choose_wanted_separator": "Choose the wanted separator",
    "download_file": "Download result file",
    "automatic_save": "Automatic result file save",
    "activate_automatic_save": "Activate automatic file save",
    "erase_resultfile_when_workflow_invalid": "Erase result file when workflow cannot be computed"
  },
  "fr": {
    "result_filename": "Nom donné au fichier résultat :",
    "enter_filename": "Entrez le nom de fichier que vous souhaitez",
    "separator_choice": "Choix du séparateur",
    "choose_all_cols": "Choisir toutes les colonnes en sortie",
    "wanted_columns": "Colonnes souhaitées",
    "download_results": "Télécharger les résultats",
    "choose_wanted_separator": "Choisissez le séparateur voulu",
    "download_file": "Télécharger le fichier résultat",
    "automatic_save": "Sauvegarde automatique du fichier résultat",
    "activate_automatic_save": "Activer la sauvegarde automatique du fichier résultat",
    "erase_resultfile_when_workflow_invalid": "Supprimer le fichier résultat quand le workflow ne peut être calculé"
  }
}
</i18n>

<script>
import _ from 'lodash'

import axios from 'axios'

import {
  download_result,
  table_columns,
  secure_filename,
  download_file,
} from '@/api/subscriptions.js'
import { GenericPath } from '@/components/object_model.js'

// import {
//   subscription_mixin,
//   brick_mixin,
//   brick_with_single_parent_mixin,
// } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'
import UnrollElement from '@/components/unroll_element.vue'
import ColumnsChoiceOptions from '@/components/columns_choice_options.vue'
import FilepathSelector from '@/components/filepath_selector.vue'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'

// *****************************************************************************

import { BasicTableInfoEntity } from '@/components/object_model.js'

export default {
  name: 'BrickProbeModel',
  components: {
    UnrollElement,
    ColumnsChoiceOptions,
    FilepathSelector,
    GenericColumnNameEdition,
  },
  // mixins: [subscription_mixin, brick_mixin, brick_with_single_parent_mixin],
  mixins: [global_brick_mixin],
  // props: ['brick_id', 'project_id', 'description_name', 'metavariables_dict'],
  data() {
    return {
      all_cols_chosen: undefined,
      available_colnames: [],
      columns_wanted: [],
      table: -1,
      filename: '',
      secured_filename: '',
      separator: undefined,
      automatic_save: false,
      generic_resultpath: new GenericPath(),
      erase_resultfile_when_workflow_invalid: true,
    }
  },
  computed: {
    disabled_result() {
      let res = this.poid_instantiated !== true
      return res
    },
    poid_instantiated() {
      let res = this.fetch_poid_status('result_poid_status', this.poid)
      return res
    },
    adapted_data() {
      let checked_parent_model_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        checked_parent_model_id = [parent_info_entity_type]
      }
      if (this.table === this.effective_parent_model_id) {
        checked_parent_model_id = this.cur_brick.parents_info
      }
      let generic_resultpath = null
      if (this.automatic_save) {
        generic_resultpath = this.generic_resultpath
      }
      let adapted = {
        uid: this.brick_id,
        parents_info: checked_parent_model_id,
        filename: this.filename,
        separator: this.separator,
        columns_wanted: _.cloneDeep(this.columns_wanted),
        choose_all_cols: this.all_cols_chosen,
        generic_resultpath,
        erase_resultfile_when_workflow_invalid: this
          .erase_resultfile_when_workflow_invalid,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
    // TODO : Put this inside a unique_parent_brick_mixin ?
    // Generalize this to every unique_parent brick ?
    effective_parent_model_id() {
      let parent_model_id = this.cur_brick.parents_info || []
      let res = -1
      if (parent_model_id.length === 1) {
        // N.B P.L : This error can be at many other places too
        res = parent_model_id[0]['uid']
      }
      return res
    },
    separatorchoiceoptions() {
      let res = [
        { value: null, text: this.$t('choose_wanted_separator') },
        { value: ',', text: this.$t('comma') + ' (,)' },
        { value: ';', text: this.$t('semicolon') + ' (;)' },
      ]
      return res
    },
    download_url() {
      let url = `/api/projects/${this.cur_brick.project_id}/results/${
        this.poid
      }`
      return url
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        // N.B PL : Maybe not necessary
        new_val = new_val || {}
        // N.B PL : n is unused right ?
        // const n = (new_val.parent_model_id || {}).length

        this.table = this.effective_parent_model_id
        // Handle cols
        this.all_cols_chosen = new_val.choose_all_cols
        this.columns_wanted = _.cloneDeep(new_val.columns_wanted)
        this.filename = new_val.filename
        this.separator = new_val.separator
        this.automatic_save = !_.isNull(new_val.generic_resultpath)
        let generic_resultpath = new_val.generic_resultpath
        if (_.isNull(generic_resultpath)) {
          generic_resultpath = new GenericPath()
        }
        this.generic_resultpath = generic_resultpath
        this.erase_resultfile_when_workflow_invalid =
          new_val.erase_resultfile_when_workflow_invalid
      },
    },
    table: {
      immediate: true,
      async handler(new_val) {
        this.available_colnames =
          (await table_columns(this.project_id, new_val)).pipe_object || []
        this.columns_wanted = _.cloneDeep(this.cur_brick.columns_wanted)
      },
    },
  },
  methods: {
    async download_result() {
      let base_url = `/api/projects/${this.cur_brick.project_id}/results/${
        this.poid
      }/`
      let res = await download_file(base_url, this.cur_brick.filename)
    },
  },
}
</script>
